













































import { Vue, Component, Prop } from "vue-property-decorator";
import ReportModel from "@/model/Report";
import { namespace } from "vuex-class";

const AppStore = namespace("App");

@Component({})
export default class SummaryAverage extends Vue {
  @Prop()
  readonly value!: ReportModel;

  @AppStore.State
  readonly reportYear!: number;
}
